import { Vector2 } from "peet-math";
import { Control } from "./control";
import { cssDummyToStyle, getStylingDummy } from "./util";
const panim = require('peter-anim-js');
import $ from "jquery"
import { ViewPort } from "./viewport";

// This is the animation that tells the user that holding its finger does something.
export class SteadyFingerAnim extends Control {
  public containerTag: JQuery<HTMLElement>;
  public style: any;
  public cssDummy: any;
  public radius: number;
  public arcNumber: number;
  public lineWidth: number;
  public position: Vector2;
  public arcDegree: number;
  public visible: boolean;
  public anim: any;

  constructor(containerTag: JQuery<HTMLElement>) {
    super();
    this.startAt = this.startAt.bind(this);
    this.stop = this.stop.bind(this);
    this.render = this.render.bind(this);
    this.containerTag = containerTag;
    this.cssDummy = getStylingDummy("steadyFingerAnim");
    this.containerTag.append($(this.cssDummy));
    this.style = cssDummyToStyle(this.cssDummy);

    this.radius = 50;
    this.arcNumber = 3;
    this.lineWidth = 10;
    
    this.position = new Vector2(0, 0);
    this.arcDegree = 0;
  }

  startAt(posOnPlan, renderCb, after) {
    // Stop previous animation
    this.stop(renderCb);
    // Wait, before anim so we don't scare people as soon as they touch the screen.
    return this.anim = new panim.WaitAnim(200).then(() => {
      this.position = posOnPlan;
      this.visible = true;
    
      const degreeEase = panim.getScaledEaseFunct(0, 2 * Math.PI, panim.easeLinear);

      return this.anim = new panim.Anim(400, (t, delta) => {
        this.arcDegree = degreeEase(t);
        return renderCb();
      }).then(() => {
        this.stop(renderCb);
        if (after != null) {
          return after();
        }
      });
    });
  }


  stop(renderCb) {
    this.visible = false;
    if (this.anim != null) {
      this.anim.stop();
    }
    return renderCb();
  }
    
  render(viewport: ViewPort, canvasCtx: CanvasRenderingContext2D) {
    if (this.visible) {
      if (canvasCtx != null) {
        const c = canvasCtx;
        const posOnView = viewport.pointPToV(this.position);
        const radiusStep = this.radius / this.arcNumber;

        c.lineWidth = this.lineWidth;
        c.strokeStyle = this.style.borderColor;

        c.beginPath();
        c.arc(posOnView.x, posOnView.y, radiusStep, 0, this.arcDegree, false);
        c.stroke();

        c.beginPath();
        c.arc(posOnView.x, posOnView.y, radiusStep * 2, 0, this.arcDegree, false);
        c.stroke();

        c.beginPath();
        c.arc(posOnView.x, posOnView.y, radiusStep * 3, 0, this.arcDegree, false);
        return c.stroke();
      }
    }
  }
}